var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0427 3.15013L10.0431 3.14982C11.1274 2.27901 12.8676 2.28411 13.968 3.1607C13.9682 3.16081 13.9683 3.16091 13.9684 3.16102L20.5141 8.39753C20.5147 8.39799 20.5152 8.39846 20.5158 8.39892C20.893 8.70708 21.2197 9.18939 21.4305 9.74096C21.6411 10.2921 21.7196 10.8698 21.6463 11.3509L20.3874 18.8844C20.3873 18.8849 20.3872 18.8854 20.3871 18.8859C20.1375 20.3188 18.7433 21.5 17.3 21.5H6.70002C5.23555 21.5 3.87256 20.3476 3.623 18.8964C3.62294 18.8961 3.62288 18.8958 3.62282 18.8954L2.36319 11.3576L2.36299 11.3564C2.28085 10.8718 2.35458 10.2929 2.56471 9.74189C2.77482 9.19091 3.10555 8.70906 3.49187 8.40083L3.49273 8.40013L10.0427 3.15013ZM12 19.25C12.6862 19.25 13.25 18.6861 13.25 18V15C13.25 14.3138 12.6862 13.75 12 13.75C11.3139 13.75 10.75 14.3138 10.75 15V18C10.75 18.6861 11.3139 19.25 12 19.25Z",
    fill: "#90A3BF",
    stroke: "#90A3BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.40d929884e2612e1f5fdb997d3ff8bd7.svg";
export { ForwardRef as ReactComponent };